export const operators = {
    MY_AGENT: 226,
};
